(function ($) {
	$.deviceDetection = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			DeviceDetection = (function ($c, o) {
				var defaults = {
				};

				var _o = {}

				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
					_CheckKnownDevices();
				},

					_CheckKnownDevices = function() {
						var nav = navigator.userAgent;
						
						if (nav.indexOf('iPad') >= 0) {
							$c.addClass('is-ipad');
						}
					},

					_OnMouseMove = function(e) {
						$c.addClass('has-mouse');
					},

					_OnTouched = function(e) {
						$c.addClass('has-touch');
						window.removeEventListener("touchstart", _OnTouched);
					},

				_BindEvents = function () {
					// Detect mouse move
					$c.one('mousemove', _OnMouseMove);

					// Detect touch
					window.addEventListener('touchstart', _OnTouched);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.deviceDetection = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('deviceDetection')) {
				var plugin = new $.deviceDetection(this, options);
				$(this).data('deviceDetection', plugin);
			}
		});
	};
})(jQuery);
